<template>
    <div class="success-callback">
        <sweet-modal blocking :title="$t('modal_subscriptions_paymentIsNotSuccessful')" ref="error" width="600" v-on:close="closeModal()">
            <div style="width:100%">
                {{$t('modal_subscriptions_somethingHappenedDuringThePayment')}}
            </div>
            <el-button @click="closeModal" style="margin-top:15px;" type="primary" size="small">
                {{$t('general_ok')}}
            </el-button>
        </sweet-modal>
    </div>
</template>

<script>
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: "ErrorCallback",
    components:{
      SweetModal
    },
    data(){
      return{
      }
    },
    mounted(){
      if (this.$route.query.companyId){
        this.openErrorModal()
      } else {
        this.$router.push( {path: '/login'})
      }
    },
    methods:{
      openErrorModal(){
        this.$refs['error'].open()
      },
      closeModal(){
        this.$router.push(`/users?companyId=${this.$route.query.companyId}&activeTab=subscriptions`);
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
    }
  }
</script>

<style lang="less" scoped>
    .success-callback {
        background: #DfE8F0;
        z-index: 0;
        height: 100vh;
    }
    .content {
        display: flex;
        height: 100vh;
        padding-top: 50px;
    }
    .wrapper {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        padding: 0 10px 10px 10px;
    }
</style>
